import { CommonTableTemplate } from 'app/common/templates-next/table-template'
import type { Survey } from 'app/common/types/surveys'

import styles from './SurveysTable.module.scss'
import {
  surveysTableCellProps,
  surveysTableDataArrange,
  surveysTableHeaders,
  surveysToTableData,
} from './table/surveysTableProps'
import { surveysTableRenderCell } from './table/surveysTableRenderCell'

type Props = {
  archived: boolean
  onSuccess: () => void
  items: Array<Survey>
  loading: boolean
  perPage: number
}

export const SurveysTable = ({
  items,
  loading,
  perPage,
  archived,
  onSuccess,
}: Props) => (
  <div className={styles.root}>
    <CommonTableTemplate
      className={styles.table}
      data={surveysToTableData(items)}
      dataArrange={surveysTableDataArrange}
      headerData={surveysTableHeaders}
      headerCellProps={surveysTableCellProps}
      cellProps={surveysTableCellProps}
      renderCell={(params) => surveysTableRenderCell(params, archived, onSuccess)}
      classNameTr={styles.row}
      loading={loading}
      skeletonRows={perPage}
      placeholder="По заданным условиям опросы не найдены"
    />
  </div>
)
